import { render, staticRenderFns } from "./luckDraw.vue?vue&type=template&id=6b18699a&scoped=true"
import script from "./luckDraw.vue?vue&type=script&lang=js"
export * from "./luckDraw.vue?vue&type=script&lang=js"
import style0 from "./luckDraw.vue?vue&type=style&index=0&id=6b18699a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18699a",
  null
  
)

export default component.exports